










import baseMixin from '@/mixins/baseMixin'
import mixins from 'vue-typed-mixins'

export default mixins(baseMixin).extend({
    async beforeMount() {
        // if(this.isAuthenticated && this.$router.currentRoute.meta?.requiredPermissions &&
        //     !isFeatureAccessible(this.$router.currentRoute.meta?.requiredPermissions, this.$store.getters.user.permissions)) {
        //     window.location.href ='/404'
        // }
        const version = sessionStorage.getItem('version')
        if(version !== process.env.VUE_APP_VERSION) {

            // Delete Cached search without editor
            // REMOVE ONCE ALL SEARCHES HAVE EDITOR
            let toBeDeletedCache = ['property', 'units', 'tenants', 'vendors']

            for (const cache of toBeDeletedCache) {
                sessionStorage.removeItem(`${cache}SearchOption`)
            }
            sessionStorage.setItem('version', process.env.VUE_APP_VERSION)
        }
    },
    computed: {
        isPublic(): boolean {
            return this.$router.currentRoute.meta?.public
        },
        shouldShowPage(): boolean {
            return (this.isAuthenticated  && !this.isForbidden) || this.isPublic
        }
    }
})
